import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { app } from "@microsoft/teams-js";
import { notification } from '../../apis/WebServices';
import { message } from 'antd';
import Loader from '../loader/Loader';
import { useParams } from 'react-router-dom';
import oopsimg from "../../assets/oops-img.png"
import notificationImage from "../../assets/notificationImage.png"
import { sanitize } from '../../utils/sanitizeHtml';


const Notification = () => {
    const { t } = useTranslation();
    const [notifications, setNotifications] = useState();
    const [notificationId, setNotificationId] = useState();
    const [loading, setLoading] = useState(true);

    const getQueryParameters = async () => {
        try {

            await app.initialize();
            const context = await app.getContext();


            let searchParams;
            if (window.location.hash.includes("?")) {
                searchParams = new URLSearchParams(window.location.hash.split("?")[1]);
            } else {
                searchParams = new URLSearchParams(window.location.search);
            }

            const paramsObj = {};
            searchParams.forEach((value, key) => {
                paramsObj[key] = value;
            });

            if (context?.subEntityId) {
                paramsObj["subEntityId"] = context.subEntityId;
            }



            if (context?.page?.subPageId) {
                const subPageParams = new URLSearchParams(context.page.subPageId.replace("|", "&"));
                const extractedVideoId = subPageParams.get("notificationId");

                if (extractedVideoId) {
                    setNotificationId(extractedVideoId);
                }
            }
            else {
                // MOBILE-ONLY FALLBACK: When Teams SDK fails on mobile, try to get notificationId from URL
                const isMobileDevice = /TeamsMobile|Android.*Teams|iPhone.*Teams|iPad.*Teams/i.test(navigator.userAgent);
                
                if (isMobileDevice) {
                    console.log('📱 Mobile: Teams context unavailable, checking URL for notificationId...');
                    
                    // Try multiple sources for notificationId
                    let notificationIdFromUrl = null;
                    
                    // Check URL search params
                    const urlParams = new URLSearchParams(window.location.search);
                    notificationIdFromUrl = urlParams.get('notificationId');
                    
                    // Check hash params if not found
                    if (!notificationIdFromUrl && window.location.hash) {
                        const hashString = window.location.hash.split('?')[1] || '';
                        const hashParams = new URLSearchParams(hashString);
                        notificationIdFromUrl = hashParams.get('notificationId');
                    }
                    
                    if (notificationIdFromUrl) {
                        console.log('📱 Mobile: Found notificationId in URL:', notificationIdFromUrl);
                        setNotificationId(notificationIdFromUrl);
                    } else {
                        console.log('📱 Mobile: No notificationId found in URL');
                        setLoading(false);
                        return;
                    }
                } else {
                    // Desktop/Web: Keep original behavior - just return
                    setLoading(false);
                    return;
                }
            }
            if (context?.searchQuery) {
                paramsObj["searchQuery"] = context.searchQuery;
            }

        } catch (error) {
        } finally {
        }
    };



    const fetchNotification = async (notificationId) => {
        try {
            // TODO: Support multiple notification types based on URL parameters
            // For now, only fetching LifeNutritionNotifications
            const response = await notification(notificationId);


            if (response?.isSuccess) {

                setNotifications(response?.data);
            }
        } catch (error) {

        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        getQueryParameters();
    }, []);



    useEffect(() => {
        // Trigger fetch when notificationId changes
        if (notificationId) {
            fetchNotification(notificationId);
        }
    }, [notificationId]);




    useEffect(() => {


        const loadAllData = async () => {
            try {
                // Only fetch notification if we have a valid notificationId
                if (notificationId) {
                    await fetchNotification(notificationId);
                }
            } catch (error) {
            } finally {
                setLoading(false);
            }
        };

        loadAllData();
    }, [notificationId]);

    if (loading) {
        return <Loader />;
    }

    return (
        <div style={{ minHeight: '100vh', backgroundColor: '#00273a' }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="whole-div" style={{ minHeight: '100vh' }}>
                        <style>{`
                            .notification-content * { color: #ffffff !important; }
                            .whole-div h3 { color: #ffffff !important; }
                        `}</style>
                        {(notifications && !loading) ? (
                            <div className="row page-content">
                                <div className="col-lg-12" style={{ paddingLeft: '12px', paddingRight: '12px' }}>
                                    <div className="d-flex align-items-center justify-content-between mb-4">
                                        <h2 className="text-white" style={{ fontSize: '2rem', fontWeight: '500' }}>
                                            {t('notification.arrived')}
                                        </h2>
                                    </div>

                                    <div className="mb-3">
                                        <h3 style={{ color: '#ffffff !important', fontSize: '1.5rem', fontWeight: '600' }}>
                                            {notifications?.subCategory && notifications?.heading 
                                                ? `${notifications.subCategory} | ${notifications.heading}`
                                                : notifications?.subCategory || notifications?.heading || 'Health Update'}
                                        </h3>
                                    </div>
                                    <div className="notification-content" style={{ maxWidth: '100%', marginTop: '20px' }}>
                                        <p
                                            style={{ 
                                                color: '#ffffff', 
                                                fontSize: '18px',
                                                lineHeight: '1.8',
                                                wordWrap: 'break-word',
                                                whiteSpace: 'pre-wrap'
                                            }}
                                            dangerouslySetInnerHTML={{ __html: sanitize(notifications?.content) }}
                                        />
                                    </div>


                                </div>
                            </div>
                        ) : (
                            <div className="row page-content">
                                <div className="col-12">
                                    <div className='text-center' style={{ paddingTop: '100px' }}>
                                        <img src={notificationImage} style={{ maxWidth: '200px', marginBottom: '20px' }} />
                                        <h2 className='text-white'>{t('notification.allCaughtUp')}</h2>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Notification;
